import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LocaleService } from '@app/system/services/locale.service';

@Component({
	selector: 'app-playlist-pagination',
	templateUrl: './playlist-pagination.component.html',
	styleUrls: ['./playlist-pagination.component.scss']
})
export class PlaylistPaginationComponent implements OnInit {

	@Input() actionBtns = { prevBtn: false, nextBtn: false };
	@Input() playlistData: any = [];
	@Input() selectedIndex = 0;
	@Output() playActions: any = new EventEmitter();

	constructor(
		public locale: LocaleService
	) {
	}

	ngOnInit(): void {
		this.playlistData.map((resp, index) => {
			if (resp.streaming) {
				this.selectedIndex = index;
			}
		});
		if (this.selectedIndex === 0) {
			this.actionBtns.prevBtn = true;
		}
		if (this.selectedIndex === (this.playlistData.length - 1)) {
			this.actionBtns.nextBtn = true;
		}
	}

	playAction(actionType) {
		if (navigator.onLine) {
			if (actionType === 'next' && this.playlistData[this.selectedIndex + 1]) {
				this.selectedIndex += 1;
			} else if (actionType === 'previous' && this.playlistData[this.selectedIndex - 1]) {
				this.selectedIndex -= 1;
			}
			this.playActions.emit(actionType);
		}
	}

}
